import {
  inboxWorkflowColumn,
  inboxWorkflowPartialMessage,
  type InboxWorkflowCellComponent,
  type InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import ReplaceWrongRecipientPreconfiguration from "./_modules/replace-wrong-recipient-preconfiguration"
import WrongRecipientActionCell from "./_modules/wrong-recipient-action-cell"
import WrongRecipientAppointmentOverviewCell from "./_modules/wrong-recipient-appointment-overview-cell"
import {
  ComparisonCell,
  ContactEditor,
  validateDraft,
  editorReason,
} from "./_modules/recipient-replacement-editor"
import { contactEditorActions } from "../../../../_shared/_logic/contact-row-actions"
import WrongRecipientPropertyCell from "./_modules/wrong-recipient-property-cell"
import WrongRecipientStatementCell from "./_modules/wrong-recipient-statement-cell"
import type {
  WrongRecipientCommitPayload,
  WrongRecipientPreviewPayload,
  WrongRecipientReplacementDraft,
  WrongRecipientReplacementRow,
} from "./contract"
import {
  buildWrongRecipientReplacementRows,
  defaultWrongRecipientReplacementDraft,
} from "./_shared/_logic/table-rows"
import { parseWrongRecipientPreview } from "./_logic/preview"

export const replaceWrongRecipientCells: Record<string, InboxWorkflowCellComponent> = {
  wrongRecipientAction: WrongRecipientActionCell,
  wrongRecipientAppointment: WrongRecipientAppointmentOverviewCell,
  wrongRecipientComparison: ComparisonCell,
  wrongRecipientProperty: WrongRecipientPropertyCell,
  wrongRecipientStatement: WrongRecipientStatementCell,
}

export const createReplaceWrongRecipientStep = (): InboxWorkflowTableStepConfig<
  WrongRecipientReplacementRow,
  WrongRecipientReplacementDraft,
  WrongRecipientCommitPayload,
  WrongRecipientPreviewPayload
> => ({
  kind: "table",
  preview: {
    kind: "wrong_recipient_replacement.replace_wrong_recipient.standard_table",
    parse: parseWrongRecipientPreview,
    errorMessage: "Termin- und Empfängerdaten konnten nicht geladen werden.",
  },
  columns: [
    inboxWorkflowColumn("action", "Korrektur", "wrongRecipientAction"),
    inboxWorkflowColumn("addressLabel", "Liegenschaft", "wrongRecipientProperty", {
      isPrimary: true,
    }),
    inboxWorkflowColumn(
      "previousCustomer",
      "Bisheriger Ansprechpartner",
      "wrongRecipientComparison",
    ),
    inboxWorkflowColumn("newCustomer", "Neuer Ansprechpartner", "wrongRecipientComparison"),
    inboxWorkflowColumn("appointment", "Termin", "wrongRecipientAppointment"),
    inboxWorkflowColumn("submittedContactLabel", "Kundenaussage", "wrongRecipientStatement"),
  ],
  buildRows: ({ workflow, step, rowOutcomes, stepPreview }) =>
    buildWrongRecipientReplacementRows({ workflow, step, rowOutcomes, preview: stepPreview }),
  draft: {
    create: defaultWrongRecipientReplacementDraft,
    validate: validateDraft,
  },
  preconfiguration: ReplaceWrongRecipientPreconfiguration,
  rowEditor: ContactEditor,
  rowEditorTitle: "Ansprechpartner bearbeiten",
  editorDisabledReason: ({ row, draft }) => editorReason(row, draft),
  rowActions: (props) => contactEditorActions(props, editorReason(props.row, props.draft)),
  buildPayload: (_row, draft) => {
    if (!draft.action) throw new Error("Empfänger-Entscheidung fehlt.")

    return draft.action === "remove"
      ? { action: "remove" }
      : {
          action: "replace",
          replacement: {
            display_name: draft.displayName.trim(),
            email: draft.email.trim() || null,
            phone: draft.phone.trim() || null,
            role: draft.role,
          },
        }
  },
  commit: {
    label: "Ansprechpartner austauschen",
    successMessage: "Ansprechpartner wurden ausgetauscht.",
    partialMessage: inboxWorkflowPartialMessage,
  },
})
